import { render, staticRenderFns } from "./PreviewFeedbackStatic.vue?vue&type=template&id=380114ba&"
import script from "./PreviewFeedbackStatic.vue?vue&type=script&lang=js&"
export * from "./PreviewFeedbackStatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports